import * as React from 'react'
import { Button, Col, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { SaveButton } from '@hyper/button'
import ModalBody from 'reactstrap/lib/ModalBody'
import { FormProvider, useForm } from 'react-hook-form'
import { RootState, useAppDispatch, useAppSelector } from '@store/index'
import { createReportTask } from '@store/actions/report-tasks-actions'
import { useReportFormRequest } from '@modules/reports/hooks/use-report-request'
import { BaseModalProps } from '@components/modals/types'
import { DateFromToInput } from '@modules/reports/user-reports/common/date-from-to-input'
import { endOfMonth, startOfMonth, startOfToday } from 'date-fns'
import { Form } from '@hyper/forms/form'

interface FormInputs {
  agreement_date_after: Date | null
  agreement_date_before: Date | null
  first_agreement_date_after: Date | null
  first_agreement_date_before: Date | null
}

export const ReportsMarketingRODOModal: React.FC<BaseModalProps> = ({ toggleIsVisible }) => {
  const reportUrl = useAppSelector(
    (state: RootState) => state.appState.appData.urls.reports.report_task_marketing_rodo_report,
  )
  const dispatch = useAppDispatch()

  const methods = useForm<FormInputs>({
    mode: 'all',
    defaultValues: {
      agreement_date_after: startOfMonth(startOfToday()),
      agreement_date_before: endOfMonth(startOfToday()),
      first_agreement_date_after: null,
      first_agreement_date_before: null,
    },
  })

  const { isLoading, action: onSubmit } = useReportFormRequest(async (payload: FormInputs) => {
    const reportTask = await dispatch(createReportTask([reportUrl, payload]))
    toggleIsVisible()

    return reportTask
  }, methods.setError)

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ModalHeader toggle={toggleIsVisible}>Raport zgód RODO</ModalHeader>
      <ModalBody>
        <FormProvider {...methods}>
          <Row>
            <Col md={12}>
              <DateFromToInput
                label="Data zaakceptowania"
                startDateName="agreement_date_after"
                endDateName="agreement_date_before"
              />
              <DateFromToInput
                label="Data pierwszego zaakceptowania"
                startDateName="first_agreement_date_after"
                endDateName="first_agreement_date_before"
              />
            </Col>
          </Row>
        </FormProvider>
      </ModalBody>
      <ModalFooter>
        <Button color="light" type="button" onClick={toggleIsVisible}>
          Zamknij
        </Button>
        <SaveButton className="btn btn-green" label="Zleć raport" labelSaving="Zlecanie.." isSaving={isLoading} />
      </ModalFooter>
    </Form>
  )
}
